import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79955740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UserInfo" }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"6em"} }, "消息盒子", -1))
const _hoisted_5 = { class: "msgCard" }
const _hoisted_6 = { class: "msgIcon" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  key: 0,
  style: {"margin-right":"15px"}
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "msgHisTime" }
const _hoisted_11 = {
  key: 1,
  style: {"margin-left":"15px"}
}

import { useStore } from '@/store'
import { computed, nextTick, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { editPageData, getListData } from '@/service/main/system'
import localCache from "@/utils/cache";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {

const store = useStore()
const name = computed(() => store.state.login.userInfo.realName)

const router = useRouter()

const handleExitPassword = () => {
  router.push({
    path: '/main/employee/updatePassword'
  })
}

const handleExitClick = () => {
  store.dispatch('login/resetToken').then(() => {
    location.reload()
  })
}

const backHomePage = () => {
  router.push({
    path: '/desk-top'
  })
}

function formatTime(date: Date) {
  return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`
}

const getTimeFormat = (dateString: string, type?: number) => {
  let date = new Date(dateString)
  if (type && type === 1) {
    date = new Date(parseFloat(dateString))
  }
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  // 比较日期
  if (date.toDateString() === today.toDateString()) {
    return formatTime(date)
  } else if (date.toDateString() === yesterday.toDateString()) {
    return '昨天'
  } else {
    return `${date.getMonth() + 1}月${date.getDate()}日`
  }
}

const getContent = (content: string) => {
  // 如果是一个完整的图片或者语音链接的话，用组件返回
  if (content.startsWith('http://') || content.startsWith('https://')) {
    if (content.endsWith('.jpg') || content.endsWith('.png')) {
      return `<img src="${content}" referrerpolicy="no-referrer" style="width: 300px; height: 100%;" />`
    } else if (content.endsWith('.mp3')) {
      return `<a href="${content}" referrerpolicy="no-referrer" target="_blank">语音链接</a>`
    }
  } else {
    return content
  }
}

const connectToWebSocket = async () => {
  const url = `${process.env.VUE_APP_HOST_PORT}/websocket/msgRemind/${store.state.login.userInfo.id}`
  await store.dispatch('system/connectWebSocket', {
    url: url,
    callback: getMessages
  })
}

const disconnectFromWebSocket = () => {
  store.dispatch('disconnectWebSocket')
}

const getHisClass = (his: any) => {
  const regex = /^(wm|wo)/i
  return regex.test(his.fromUser)
}

const batchRead = () => {
  ElMessageBox.confirm('确认要全部设为已读吗？', '提醒', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  })
    .then(() => {
      let pageUrl = `/main/instantMessage/batchRead`
      editPageData(pageUrl, {}).then(() => {
        getMessages()
      })
    })
    .catch(() => {
      console.log('用户点击了取消')
    })
}

const previewImgUrl = ref(window.location.origin + '/previewImg.html?url=')

const handlePreview = (msg: any) => {
  if (msg.msgContent.match(/\.(jpg|jpeg|png|gif)$/)) {
    // 获取屏幕的宽度和高度
    const screenWidth = window.screen.width
    const screenHeight = window.screen.height

    const width = screenWidth * 0.5
    const height = screenWidth * 0.5

    // 计算新窗口的左上角位置，使其居中
    const leftPosition = screenWidth / 2 - width / 2
    const topPosition = screenHeight / 2 - height / 2

    // 创建弹出窗口
    const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
    window.open(previewImgUrl.value + msg.msgContent, '图片预览', options)
  } else {
    window.open(msg.msgContent, '_blank')
  }
}

const openMsg = (msg: any) => {
  if (msg.readStatus == '0') {
    if (msg.businessCode == 'IM_004') {
      handlePreview(msg)
    } else {
      ElMessageBox.confirm(
        msg.msgContent.replaceAll('\n', '<br/>'),
        '发送人:' + msg.sender,
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '设为已读',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          let pageUrl = `/main/instantMessage/updateReadStatus/${msg.id}`
          editPageData(pageUrl, {}).then(() => {
            getMessages()
          })
        })
        .catch(() => {
          console.log('用户点击了取消')
        })
    }
  } else {
    ElMessageBox.alert(msg.msgContent, '发送人:' + msg.sender, {
      confirmButtonText: '关闭'
    })
      .then(() => {
        console.log('用户点击了确定')
      })
      .catch(() => {
        console.log('用户点击了取消')
      })
  }
}
const msgWin = ref(false)
const currentMsgHis = ref([])
const openMsgHis = async (msg: any) => {
  msgWin.value = true
  currentMsgHis.value = []
  currentMsgHis.value = await getListData(
    `/main/instantMessage/getDetail/${msg.id}`,
    {}
  )
}

const drawer = ref(false)
const direction = ref('rtl')
const messages: any = ref([])
const canvases = ref([])

const openMsgBox = () => {
  console.log(drawer.value)
  drawer.value = true
  // 确保DOM更新完成后再绘制
  nextTick(() => {
    canvases.value.forEach((canvasRef, index) => {
      if (canvasRef.value) {
        drawTextOnCanvas(canvasRef.value, messages.value[index].sender, index)
      }
    })
  })
}
const bgColors = ['#0089ff']
const fontColors = ['#ffffff']
const drawTextOnCanvas = (
  canvas: HTMLCanvasElement,
  text: string,
  index: number
) => {
  const ctx = canvas[0].getContext('2d')
  if (!ctx) return

  // 设置 canvas 大小
  canvas[0].width = 54
  canvas[0].height = 54

  // 设置字体样式
  ctx.font = 'bold 32px "宋体"'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'

  // 随机背景色
  const randomBackgroundColor = bgColors[index % bgColors.length]
  ctx.fillStyle = randomBackgroundColor

  // 绘制背景色
  ctx.beginPath()
  ctx.arc(canvas[0].width / 2, canvas[0].height / 2, 54, 0, Math.PI * 2)
  ctx.closePath()
  ctx.fill()

  // 绘制文字
  ctx.fillStyle = fontColors[index % fontColors.length]
  ctx.fillText(text.substring(0, 1), canvas[0].width / 2, canvas[0].height / 2)
}

const getMessages = async () => {
  messages.value = await getListData('/main/instantMessage/getList', {})
  // 初始化canvases数组
  canvases.value = messages.value.map(() => ref<HTMLCanvasElement | null>(null))
  if (drawer.value) {
    // 确保DOM更新完成后再绘制
    nextTick(() => {
      canvases.value.forEach((canvasRef, index) => {
        if (canvasRef.value) {
          drawTextOnCanvas(canvasRef.value, messages.value[index].sender, index)
        }
      })
    })
  }
}

const getEmpData = async () => {
  let userList = await getListData('/main/employee/queryEmpList', {})
  localCache.setCache('empData', userList)

  let corpData = await getListData('/main/enterpriseWechat/config/listAll', {})
  localCache.setCache('companyData', corpData)
}



onMounted(() => {
  connectToWebSocket()
  getMessages()
  getEmpData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_badge, {
      "is-dot": messages.value.filter((item) => item.readStatus === '0').length > 0,
      class: "item",
      type: "danger"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: _normalizeClass(
          messages.value.filter((item) => item.readStatus === '0').length > 0
            ? 'shake'
            : ''
        ),
          type: "primary",
          circle: "",
          size: "mini",
          icon: "el-icon-message",
          onClick: openMsgBox
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 8, ["is-dot"]),
    _createVNode(_component_el_dropdown, null, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { onClick: handleExitPassword }, {
              default: _withCtx(() => [
                _createTextVNode("修改密码")
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, {
              divided: "",
              onClick: handleExitClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("退出登录")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            size: "small",
            class: "avatar",
            src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
          }),
          _createElementVNode("span", null, _toDisplayString(name.value), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_drawer, {
      "custom-class": "msgBox",
      title: "消息盒子",
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
      direction: direction.value,
      size: "20%"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, [
            _createVNode(_component_el_tag, {
              size: "mini",
              type: "primary",
              class: "msgHis",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (batchRead()), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 一键已读")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { style: {"height":"800px"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  onClick: _withModifiers(($event: any) => (openMsg(message)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(), _createElementBlock("canvas", {
                          key: index,
                          ref_for: true,
                          ref: canvases.value[index],
                          width: "66",
                          height: "66",
                          class: "avatar"
                        }))
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass('msgContent sts' + message.readStatus)
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, _toDisplayString(message.sender), 1),
                          _createElementVNode("div", null, _toDisplayString(getTimeFormat(message.sendTime)), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass('content' + message.readStatus)
                        }, [
                          (message.readStatus === '0')
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                size: "mini",
                                type: "danger"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("未读")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (message.readStatus === '1')
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 1,
                                size: "mini",
                                type: "success"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("已读")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(message.businessCode == 'IM_004'
                      ? '每日跟踪标准小贴士'
                      : message.msgContent), 1)
                        ], 2),
                        (
                    message.businessCode == 'IM_001' ||
                    message.businessCode == 'IM_002'
                  )
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              size: "mini",
                              type: "primary",
                              class: "msgHis",
                              onClick: _withModifiers(($event: any) => (openMsgHis(message)), ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 历史消息")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "direction"]),
    _createVNode(_component_el_dialog, {
      modelValue: msgWin.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((msgWin).value = $event)),
      title: "历史消息",
      width: "500"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMsgHis.value, (his, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(getHisClass(his) ? 'msgHisLeft' : 'msgHisRight')
          }, [
            (getHisClass(his))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_avatar, {
                    shape: "square",
                    size: 50
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_card, {
              shadow: "hover",
              style: {"margin-bottom":"6px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(getHisClass(his) ? 'msgHisCardLeft' : 'msgHisCardRight')
                }, [
                  _createElementVNode("div", {
                    class: "msgHisContent",
                    innerHTML: getContent(his.content)
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(getTimeFormat(his.msgTime, 1)), 1)
                ], 2)
              ]),
              _: 2
            }, 1024),
            (!getHisClass(his))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_el_avatar, {
                    shape: "square",
                    size: 50
                  })
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})